import { AuthenticateData } from 'graphql/AuthQueries'
import { createContext, useContext, useState } from 'react'
import { PlatformContext } from 'PlatformContext'
import { Tracker, TrackerUser } from 'Tracker'
import Cookies from 'universal-cookie'
import { APP_BASENAME } from 'index'

type AuthContextState = AuthenticateData & {
  canLetLogin: Boolean
}

type AuthContextData = AuthContextState & {
  login(authData: AuthenticateData, authType: string): void
  newApiKey(apiKey: string): void
  logout(): void
  letLogin(): void
}

const initialState: AuthContextState = {
  user: null,
  account: null,
  accounts: null,
  connection: null,
  requests: null,
  level: 0,
  canLetLogin: false,
  autoCreated: false
}

const AuthContext = createContext<AuthContextData>({
  ...initialState,
  login: () => {},
  newApiKey: () => {},
  logout: () => {},
  letLogin: () => {}
})

function AuthProvider(props: any) {
  const platform = useContext(PlatformContext);

  const [state, setState] = useState<AuthContextState>({
    ...initialState,
    canLetLogin: !platform.isEmbedded
  })

  const login = (authData: AuthenticateData, authType: String) => {
    platform.authService.storeAuthData(authData);

    if(authData.roles?.includes("NoTracking")){
      const cookies = new Cookies();
      cookies.set("disableAnalytics", "true", { path: '/' + APP_BASENAME + '/' });
    }

    const trackerUser: TrackerUser = {
      id: authData.user?.id || null,
      level: authData.level
    }

    Tracker.event("action.login.user", trackerUser, {
      login: {
        method: authType
      }
    })
    setState({
      ...state,
      ...authData
    })
  }

  const newApiKey = (apiKey: string) => {
    setState({
      ...state,
      apiToken: apiKey
    })
  }

  function logout() {
    platform.authService.deleteAuthData();

    const trackerUser: TrackerUser = {
      id: state.user?.id || null,
      level: state.level
    }

    Tracker.event("action.logout.user", trackerUser, null)

    setState({
      ...state,
      account: null,
      user: null
    })
  }

  function letLogin() {
    setState({
      ...state,
      canLetLogin: true
    })
  }

  return (
    <AuthContext.Provider
      value={{
        account: state.account,
        accounts: state.accounts,
        user: state.user,
        connection: state.connection,
        level: state.level,
        apiToken: state.apiToken,
        roles: state.roles,
        requests: state.requests,
        autoCreated: state.autoCreated,
        rememberMe: state.rememberMe,
        canLetLogin: state.canLetLogin,
        letLogin, login, newApiKey, logout}}
      {...props}
    />
  )
}

export { AuthContext, AuthProvider };
